export function provisionalCentralUser(actor) {
  const tenant = actor?.tenant || {};
  const centralUser = actor?.user || {};
  const roleMap = {
    owner: 'admin',
    manager: 'admin',
    operator: 'vendedor',
    accountant: 'contador'
  };
  const centralRole = String(centralUser.role || '').trim().toLowerCase();
  const localRole = centralUser.platformOwner === true
    ? 'owner'
    : (roleMap[centralRole] || 'vendedor');
  const username = String(centralUser.username || '').trim().toLowerCase();
  const displayName = String(
    centralUser.displayName || centralUser.display_name || username || 'Usuario'
  ).trim();
  const tenantId = String(tenant.id || '').trim().toLowerCase();

  return {
    id: centralUser.id || null,
    user_id: centralUser.id || null,
    username,
    nome: displayName,
    cargo: localRole,
    perfil_acesso: localRole,
    tenant_id: 'tenant-local',
    central_tenant_id: tenantId,
    central_tenant_slug: String(tenant.slug || '').trim().toLowerCase(),
    central_tenant_name: String(
      tenant.name || tenant.displayName || tenant.display_name || ''
    ).trim(),
    central_user_id: String(centralUser.id || '').trim().toLowerCase(),
    central_role: centralRole,
    tenant_modules: tenant.modules || {},
    tenant_modules_version: tenant.modulesVersion || tenant.modules_version || 0,
    tenant_data_authority: tenant.dataAuthority || tenant.data_authority || {},
    persistence_mode: String(
      tenant.persistenceMode || tenant.persistence_mode || 'cloud_authoritative'
    ).trim().toLowerCase(),
    session_mode: 'central',
    tenant
  };
}
